import { AppActionType } from 'components/app/constants'

export const getDefaultState = () => ({
    busy: false,
    toast: {
        message: '',
        type: '',
    },
    isHorizontal: true,
    drawer: false,
})

export default (state = getDefaultState(), action) => {
    switch (action.type) {
        case AppActionType.APP_BUSY:
            return setAppBusy(state, action.payload)
        case AppActionType.SET_TOAST_MESSAGE:
            return setToastMessage(state, action.payload)
        case AppActionType.REMOVE_TOAST_MESSAGE:
            return removeToastMessage(state)
        case AppActionType.SET_DRAWER_STATE:
            return setDrawerState(state)
        case AppActionType.TOGGLE_ORIENTATION:
            return toggleOrientation(state)
        default:
            return state
    }
}

const setAppBusy = (state, { busy }) => {
    return {
        ...state,
        busy,
    }
}

const setToastMessage = (state, { message, type }) => {
    return {
        ...state,
        toast: { message, type },
    }
}

const removeToastMessage = (state) => {
    return {
        ...state,
        toast: { message: '', type: '' },
    }
}
function setDrawerState(state) {
    return {
        ...state,
        drawer: !state.drawer,
    }
}

const toggleOrientation = (state) => {
    return {
        ...state,
        isHorizontal: !state.isHorizontal,
    }
}
